import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchProductGroups } from 'src/api/productGroup';
import {
    FETCH_PRODUCT_GROUPS,
    requestProductGroups,
    requestProductGroupsFailure,
    requestProductGroupsSuccess,
} from './actions';

function* fetchProductGroupsSaga(action: AnyAction): SagaIterator {
    yield put(requestProductGroups());

    const { error, response } = yield call(fetchProductGroups, action.rootGroup);

    if (error) {
        yield put(requestProductGroupsFailure(error));
    } else {
        yield put(requestProductGroupsSuccess(response));
    }
}

export function* generateFetchProductGroups() {
    yield takeLatest(FETCH_PRODUCT_GROUPS, fetchProductGroupsSaga);
}
